import brandConfig from './brandConfig';
import appsConfig from './appsConfig';

const appConfig = {
	env: process.env.NODE_ENV,
	isStaging: window.location.hostname === 'portal.sportsfantasyhq.com',
	isCI: window.location.hostname === 'ci-portal.sportsfantasyhq.com',
	bugsnag: {
		enabled: process.env.REACT_APP_BUGSNAG_ENABLED === 'true',
		apiKey: process.env.REACT_APP_BUGSNAG_KEY,
		releaseStage: process.env.NODE_ENV,
		enabledReleaseStages: ['production', 'staging'],
	},
	greenId: {
		accountId: process.env.REACT_APP_GREENID_ACCOUNT_ID,
		apiCode: process.env.REACT_APP_GREENID_API_CODE,
		env: process.env.REACT_APP_GREENID_ENV,
	},
	brand: brandConfig,
	clientApps: appsConfig,
	portal: {
		apiUrl: process.env.REACT_APP_API_ENDPOINT,
		socketEnabled: process.env.REACT_APP_ENABLE_SOCKETS === 'true',
		pusherHost: process.env.REACT_APP_PUSHER_HOST,
		pusherKey: process.env.REACT_APP_PUSHER_KEY,
		pusherCluster: process.env.REACT_APP_PUSHER_CLUSTER,
		spendingLimit: process.env.REACT_APP_SPENDING_LIMIT_ENABLED === 'true',
		inactivityTimeout: process.env.REACT_APP_INACTIVITY_TIMEOUT
			? parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT, 10)
			: 0,
		blueshyftGeneralApi: process.env.REACT_APP_BLUESHYFT_GENERAL_API,
		blueshyftGeneralApiKey: process.env.REACT_APP_BLUESHYFT_GENERAL_APIKEY,
		blueshyftQrUrl: process.env.REACT_APP_BLUESHYFT_QR_URL,
		appVersion: process.env.REACT_APP_VERSION,
		defaultDraftstars: process.env.REACT_APP_DEFAULT_DRAFTSTARS === 'true',
		whatsNewSlidesVersion: process.env.REACT_APP_WHATS_NEW_SLIDES_VERSION,
	},
	wagering: {
		baseUrl: process.env.REACT_APP_WAGERING_BASE_URL,
	},
	geocomply: {
		enabled: process.env.REACT_APP_GEOCOMPLY_ENABLED === 'true',
		installerKey: process.env.REACT_APP_GEOCOMPLY_INSTALLER_KEY,
		envID: process.env.REACT_APP_GEOCOMPLY_ENV_ID,
		sdkVersion: process.env.REACT_APP_GEOCOMPLY_SDK_VERSION,
		idComplyEnabled: process.env.REACT_APP_IDCOMPLY_ENABLED,
	},
	idComply: {
		enabled: process.env.REACT_APP_IDCOMPLY_ENABLED === 'true',
	},
	paysafe: {
		key: process.env.REACT_APP_PAYSAFE_KEY,
	},
	fantasy: {
		enabled: process.env.REACT_APP_FANTASY_ENABLED === 'true',
		baseUrl: process.env.REACT_APP_FANTASY_BASE_URL,
	},
	fatZebra: {
		enabled: process.env.REACT_APP_FATZEBRA_ENABLED === 'true',
		userName: process.env.REACT_APP_FATZEBRA_USERNAME,
		sdk: process.env.REACT_APP_FATZEBRA_SDK,
	},
	recaptchaSiteId: process.env.REACT_APP_RECAPTCHA_SITE_ID,
	googleMapsKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
	googleTagManagerID: process.env.REACT_APP_GTM_ID,
	regions: {
		language: process.env.REACT_APP_REGIONS_LANGUAGE || 'enAU',
		isUS: process.env.REACT_APP_IS_US === 'true',
		usState: process.env.REACT_APP_US_STATE || 'IA', // default to iowa
	},
};

export default appConfig;
